"use client";

const MESSAGE = 'Розігруємо MacBook Air 2025! Встигни взяти участь — залишай заявку!';

export default function AnimationBanner() {
  return (
    <div
      data-meta="AnimationBanner"
      className="overflow-hidden bg-green-500 py-2"
    >
      <div className="relative w-full h-full">
        <div className="marquee-container">
          <p className="marquee">
            <span>{MESSAGE}</span>
          </p>
          <p className="marquee marquee-duplicate">
            <span>{MESSAGE}</span>
          </p>
        </div>
      </div>

      <style jsx>{`
        .marquee-container {
          position: relative;
          display: flex;
          overflow: hidden;
          white-space: nowrap;
          height: 100%;
        }

        .marquee,
        .marquee-duplicate {
          display: inline-flex;
          gap: 1rem;
          justify-content: center;
          align-items: center;
          font-size: 1.5rem;
          font-weight: bold;
          text-transform: uppercase;
          color: white;
          min-width: 100%;
          animation: scroll 8s linear infinite;
        }

        @media (max-width: 880px) {
          .marquee,
          .marquee-duplicate {
            font-size: 1rem;
            min-width: 150%;
          }
        }

        @keyframes scroll {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </div>
  );
}
